<template>
  <v-layout row>
    <v-flex sm12 offset-sm0>
      <v-card color="white" flat>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 sm4>
                <label style="font-size:16px; float:left; overflow: hidden; white-space: nowrap;"> Submission number: </label>
                <label style="font-size:16px; float:left; padding-left: 10px; overflow: hidden; white-space: nowrap;" > <strong>  {{ this.applicationnumber }}  </strong> </label>
              </v-flex>
              <v-flex xs12 sm2>
                <v-select
                  v-model="countryid"
                  label="Country"
                  single-line
                  bottom
                  item-value="id"
                  item-text="name"
                  :items="countrylist"
                  readonly
                ></v-select>
              </v-flex>
              <v-flex xs12 sm3 pl-4>
                <v-text-field
                  slot="activator"
                  label="Submission date"
                  v-model="datesubmitted"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-form v-model="valid" ref="form" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 sm3>
                <v-text-field
                  label="Company"
                  v-model="company"
                  :rules="companyRules"
                  :readonly="readonly"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 offset-sm1>
                  <v-select
                    v-model="cropid"
                    :rules="cropRules"
                    label="Crop"
                    single-line
                    bottom
                    item-value="id"
                    item-text="name"
                    :items="cropslist"
                    :readonly="readonly"
                  ></v-select>
              </v-flex>
              <v-flex xs12 sm3 pl-4>
                <v-text-field
                  class="myclass"
                  label="Variety"
                  v-model="variety"
                  :rules="varietyRules"
                  :readonly="readonly"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm9>
                <v-text-field
                class="myclass"
                  multiLine
                  rows="3"
                  label="Comments"
                  v-model="comment"
                  maxlength="256"
                  :readonly="readonlycomment"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 sm2>
                  <v-select
                    v-model="statusid"
                    label="Status"
                    single-line
                    bottom
                    item-value="id"
                    item-text="name"
                    :items="statuslist"
                    :readonly="readonlystatus"
                    v-if="!readonlystatus"
                  ></v-select>
                  <v-select
                    v-model="statusid"
                    label="Status"
                    single-line
                    bottom
                    item-value="id"
                    item-text="name"
                    :items="statuslistnsa"
                    :readonly="readonlystatusnsa"
                    v-if="!readonlystatusnsa"
                  ></v-select>
              </v-flex>
              <v-flex xs12 sm4 pr-5>
              <div style="float:right;">
                <v-btn round color="primary" dark @click="update" v-if="showupdatebtn">Update</v-btn>
              </div>
              </v-flex>
            </v-layout>
            </v-form>
          </v-container>
          <hr>
        </v-card-text>
    </v-card>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  watch: {
    applicationidsubmitted: function () {
      console.log('watch applicationidsubmitted')
      let tempapplicationlist = this.$store.getters.getApplicationslistsubmitted
      try {
        if (typeof tempapplicationlist[this.applicationidsubmitted] === 'undefined') {
          this.formvaluesreset()
        } else {
          this.setformvalues(tempapplicationlist, this.applicationidsubmitted)
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    },
    applicationidpending: function () {
      console.log('watch applicationidpending')
      let tempapplicationlist = this.$store.getters.getApplicationslistpending
      try {
        if (typeof tempapplicationlist[this.applicationidpending] === 'undefined') {
          this.formvaluesreset()
        } else {
          this.setformvalues(tempapplicationlist, this.applicationidpending)
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    },
    applicationidverified: function () {
      console.log('watch applicationidpending')
      let tempapplicationlist = this.$store.getters.getApplicationslistverified
      try {
        if (typeof tempapplicationlist[this.applicationidverified] === 'undefined') {
          this.formvaluesreset()
        } else {
          this.setformvalues(tempapplicationlist, this.applicationidverified)
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    },
    applicationidapproved: function () {
      let tempapplicationlist = this.$store.getters.getApplicationslistapproved
      try {
        if (typeof tempapplicationlist[this.applicationidapproved] === 'undefined') {
          this.formvaluesreset()
        } else {
          this.setformvalues(tempapplicationlist, this.applicationidapproved)
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    },
    applicationidrejected: function () {
      console.log('watch applicationidrejected')
      let tempapplicationlist = this.$store.getters.getApplicationslistrejected
      try {
        if (typeof tempapplicationlist[this.applicationidrejected] === 'undefined') {
          this.formvaluesreset()
        } else {
          this.setformvalues(tempapplicationlist, this.applicationidrejected)
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    },
    applicationidcancelled: function () {
      console.log('watch applicationidpending')
      let tempapplicationlist = this.$store.getters.getApplicationslistcancelled
      try {
        if (typeof tempapplicationlist[this.applicationidcancelled] === 'undefined') {
          this.formvaluesreset()
        } else {
          this.setformvalues(tempapplicationlist, this.applicationidcancelled)
        }
      } catch (error) {
        console.log('undefined list, must be empty')
      }
    }
  },
  computed: {
    applicationidsubmitted () {
      return this.$store.getters.getSelectedapplicationidsubmitted
    },
    applicationidpending () {
      return this.$store.getters.getSelectedapplicationidpending
    },
    applicationidapproved () {
      return this.$store.getters.getSelectedapplicationidapproved
    },
    applicationidrejected () {
      return this.$store.getters.getSelectedapplicationidrejected
    },
    applicationidverified () {
      return this.$store.getters.getSelectedapplicationidverified
    },
    applicationidcancelled () {
      return this.$store.getters.getSelectedapplicationidcancelled
    },
    applicationactivepage () {
      return this.$store.getters.getApplicationactivepage
    },
    readonly () {
      let defaultvalue = true
      if (this.applicationactivepage === 'submittedapplications') {
        if ((this.$store.getters.getUsertype === 'user') || (this.$store.getters.getUsertype === 'admin')) {
          defaultvalue = false
        }
      }
      return defaultvalue
    },
    readonlystatus () {
      let defaultvalue = true
      if (this.$store.getters.getUsertype === 'admin') {
        defaultvalue = false
      }
      return defaultvalue
    },
    readonlystatusnsa () {
      let defaultvalue = true
      if ((this.$store.getters.getUsertype === 'user') && (this.applicationactivepage === 'submittedapplications')) {
        defaultvalue = false
      }
      return defaultvalue
    },
    readonlycomment () {
      if (((this.$store.getters.getUsertype === 'user') && (this.applicationactivepage === 'submittedapplications')) || (this.$store.getters.getUsertype === 'admin')) {
        return false
      } else {
        return true
      }
    },
    showupdatebtn () {
      let defaultvalue = false
      if ((this.applicationactivepage === 'submittedapplications') && (this.$store.getters.getUsertype === 'user')) {
        defaultvalue = true
      }
      if (this.$store.getters.getUsertype === 'admin') {
        defaultvalue = true
      }
      return defaultvalue
    },
    cropRules () {
      return this.$store.getters.getCroprules
    },
    companyRules () {
      return this.$store.getters.getCompanyrules
    },
    commentRules () {
      return this.$store.getters.getCommentrules
    },
    newcommentRules () {
      return this.$store.getters.getNewcommentrules
    },
    varietyRules () {
      return this.$store.getters.getVarietyrules
    },
    cropslist () {
      return this.$store.getters.getCrops
    },
    countrylist () {
      return this.$store.getters.getCountries
    }
  },
  data () {
    return {
      data: new FormData(),
      valid: true,
      cropid: null,
      statusid: null,
      oldstatusid: null,
      countryid: null,
      company: null,
      datesubmitted: null,
      applicationnumber: null,
      applicationid: null,
      statuslist: [
        { id: 0, name: 'Submitted' },
        { id: 1, name: 'Pending' },
        { id: 3, name: 'Approved' },
        { id: 4, name: 'Rejected' },
        { id: 5, name: 'Cancelled' }
      ],
      statuslistnsa: [
        { id: 0, name: 'Submitted' },
        { id: 1, name: 'Pending' }
      ]
    }
  },
  methods: {
    setformvalues (tempapplicationlist, valueapplicationid) {
      console.log('set form values')
      console.log(tempapplicationlist)
      console.log(valueapplicationid)
      this.cropid = tempapplicationlist[valueapplicationid].crop_id
      this.statusid = tempapplicationlist[valueapplicationid].status_id
      this.oldstatusid = this.statusid
      this.countryid = tempapplicationlist[valueapplicationid].country_id
      this.company = tempapplicationlist[valueapplicationid].company
      this.variety = tempapplicationlist[valueapplicationid].variety
      this.comment = tempapplicationlist[valueapplicationid].comment
      this.datesubmitted = this.formatDate(tempapplicationlist[valueapplicationid].submissiondate)
      this.applicationnumber = tempapplicationlist[valueapplicationid].applnumber
      this.applicationid = valueapplicationid
    },
    formvaluesreset () {
      console.log('reset form values')
      this.cropid = null
      this.statusid = null
      this.oldstatusid = this.statusid
      this.countryid = null
      this.company = null
      this.variety = null
      this.comment = ''
      this.datesubmitted = null
      this.applicationnumber = null
      this.applicationid = null
    },
    update () {
      if (this.$refs.form.validate()) {
        this.data.append('crop_id', this.cropid)
        this.data.append('status_id', this.statusid)
        this.data.append('companyname', this.company)
        this.data.append('comment', this.comment)
        this.data.append('variety', this.variety)
        this.data.append('country_id', this.countryid)
        this.data.append('id', this.applicationid)
        this.submitapplicationform(this.data)
        if (this.statusid !== this.oldstatusid) {
          this.$refs.form.reset()
          this.applicationnumber = null
          this.countryid = null
          this.datesubmitted = null
        }
      } else {
        console.log('applicationdetails form could not be validated')
      }
    },
    resetformvalues () {
      if (this.applicationactivepage === 'submittedapplications') {
        let tempapplicationlist = this.$store.getters.getApplicationslistsubmitted
        try {
          if (typeof tempapplicationlist[this.applicationidsubmitted] === 'undefined') {
            this.formvaluesreset()
          } else {
            this.setformvalues(tempapplicationlist, this.applicationidsubmitted)
          }
        } catch (error) {
          console.log('undefined list, must be empty')
        }
      }
      if (this.applicationactivepage === 'pendingapplications') {
        let tempapplicationlist = this.$store.getters.getApplicationslistpending
        try {
          if (typeof tempapplicationlist[this.applicationidpending] === 'undefined') {
            this.formvaluesreset()
          } else {
            this.setformvalues(tempapplicationlist, this.applicationidpending)
          }
        } catch (error) {
          console.log('undefined list, must be empty')
        }
      }
      if (this.applicationactivepage === 'approvedapplications') {
        let tempapplicationlist = this.$store.getters.getApplicationslistapproved
        try {
          if (typeof tempapplicationlist[this.applicationidapproved] === 'undefined') {
            this.formvaluesreset()
          } else {
            this.setformvalues(tempapplicationlist, this.applicationidapproved)
          }
        } catch (error) {
          console.log('undefined list, must be empty')
        }
      }
      if (this.applicationactivepage === 'rejectedapplications') {
        let tempapplicationlist = this.$store.getters.getApplicationslistrejected
        try {
          if (typeof tempapplicationlist[this.applicationidrejected] === 'undefined') {
            this.formvaluesreset()
          } else {
            this.setformvalues(tempapplicationlist, this.applicationidrejected)
          }
        } catch (error) {
          console.log('undefined list, must be empty')
        }
      }
      if (this.applicationactivepage === 'verifiedapplications') {
        let tempapplicationlist = this.$store.getters.getApplicationslistverified
        try {
          if (typeof tempapplicationlist[this.applicationidverified] === 'undefined') {
            this.formvaluesreset()
          } else {
            this.setformvalues(tempapplicationlist, this.applicationidverified)
          }
        } catch (error) {
          console.log('undefined list, must be empty')
        }
      }
      if (this.applicationactivepage === 'cancelledapplications') {
        let tempapplicationlist = this.$store.getters.getApplicationslistcancelled
        try {
          if (typeof tempapplicationlist[this.applicationidcancelled] === 'undefined') {
            this.formvaluesreset()
          } else {
            this.setformvalues(tempapplicationlist, this.applicationidcancelled)
          }
        } catch (error) {
          console.log('undefined list, must be empty')
        }
      }
    },
    submitapplicationform (formdata) {
      this.$store.dispatch('updateApplication', formdata)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [thedate] = date.split(' ')
      return `${thedate}`
    }
  },
  created () {
    this.resetformvalues()
  }
}
</script>
<style>
.select-style {
    border: 1px solid #ccc;
    width: 120px;
    border-radius: 3px;
    overflow: hidden;
    background: #fafafa no-repeat url('../../../assets/images/sort_desc.png') 90% 40%;
}
.select-style select {
    padding: 5px 8px;
    width: 130%;
    border: none;
    box-shadow: none;
    background: transparent;
    background-image: none;
    -webkit-appearance: none;
}
.select-style select:focus {
    outline: none;
}
.dropdown_label{
  font-size: 12px;
  color: rgba(0,0,0,.54);
  text-align: left !important;
  float:left;
}
.input-group__input textarea {
  resize: none;
}
.input-group--text-field input, .input-group--text-field textarea {
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/applications/Applicationdetails.vue